import React from 'react'

const NoPolicyRefund = () => {
    return (
        <div style={{
            padding: 40
        }}>

            <div>
                <h1>No Refund Policy</h1>
                <p>Thank you for shopping with RandK north-east pvt ltd. Please read our policy on refunds carefully to understand how it applies to you.</p>

                <h5>No Refunds</h5>
                <p>Due to the nature of our digital products and services, all sales are final. We do not provide refunds or exchanges once a purchase is made. If you have any issues with the product you purchased, please contact us at randkpvtlimted@gmail.com with details of the issue.</p>

                <h5>Exceptions</h5>
                <p>All items are non-refundable and non-exchangeable. These include:</p>
                <ul>
                    <li>Custom digital products</li>
                    <li>Products purchased on sale</li>
                </ul>

                <h5>Contact Us</h5>
                <p>If you have any questions about our No Refund Policy, please contact us:</p>
                <ul>
                    <li>By email: randkpvtlimted@gmail.com</li>
                </ul>
            </div>

        </div>
    )
}

export default NoPolicyRefund